import { useCallback, useState } from 'react';
import mqtt from '@/plugins/mqtt/index.js';
import { useModel } from 'umi';
import { log } from '@/utils/log';

export default function MqttModel() {
  // 推送内容
  const [wsRes, setWsRes] = useState<any>({});
  // 推送时间 - 更新依赖
  const [wsSendTime, setWsSendTime] = useState<number>(0);
  const setWsResCb = useCallback((val) => {
    setWsRes(val);
    if (val?.sendTime) {
      setWsSendTime(val.sendTime);
    }
  }, []);
  const [wsId] = useState(Date.now());

  const userId = useModel(
    '@@initialState',
    (model) => model.initialState?.userId
  );
  const msgCb = (rs: any) => {
    setWsResCb(rs);
    try {
      const val = JSON.stringify(rs);
      localStorage.setItem('wsRes', val);
    } catch (e) {
      console.log('stringfyError', e);
    }
  };

  // 移除wsList中当前页wsId
  const removeWsId = () => {
    const localWsList: number[] = JSON.parse(
      localStorage.getItem('wsList') || '[]'
    );
    // 当前页面存在ws链接
    if (localWsList[0] === wsId) {
      localWsList.shift();
      localStorage.setItem('wsList', JSON.stringify(localWsList));
    } else {
      const list = localWsList.filter((i) => i !== wsId);
      localStorage.setItem('wsList', JSON.stringify(list));
    }
  };
  const createWsConnect = () => {
    log.log('createWsConnect', wsId);
    mqtt.createWebSocket({
      userId,
      deviceId: `epc-${Date.now()}`,
      msgCb: (rs: any) => {
        console.log({rs})
        setWsResCb(rs);
        try {
          const val = JSON.stringify(rs);
          localStorage.setItem('wsRes', val);
        } catch (e) {
          console.log('stringfyError', e);
        }
      },
    });
  };
  const storageEventHandler = (e: StorageEvent) => {
    if (e.key === 'wsRes') {
      const wsRs = JSON.parse(e.newValue || '{}');
      setWsResCb(wsRs);
    }
    if (e.key === 'wsList') {
      const wsIdList: any[] = JSON.parse(e.newValue || '[]');
      log.log('storageEventHandler wslit', wsIdList, wsId);
      if (wsIdList[0] === wsId) {
        createWsConnect();
      }
    }
  };

  const undloadMqttHandler = () => {
    mqtt.disconnectWebsocket();
    window.removeEventListener('storage', storageEventHandler);
    removeWsId();
    window.removeEventListener('beforeunload', undloadMqttHandler);
  };
  const addWsId = (localWsList: any) => {
    const list = localWsList;
    list.push(wsId);
    localStorage.setItem('wsList', JSON.stringify(list));
  };

  const initMqtt = () => {
    // 指定2个localStorage： wsList: 所有同源页面wsId数组， wsRes 所有同源页面共享ws数据
    // 开发时热更新不会触发unmount，导致wsList累积和页签数量对不上，需要手动清除
    const localWsList = JSON.parse(localStorage.getItem('wsList') || '[]');
    addWsId(localWsList);
    window.addEventListener('beforeunload', undloadMqttHandler);
    // storage事件只会在同一浏览器中不同标签页间触发
    window.addEventListener('storage', storageEventHandler);
    log.log('initMqtt::', localWsList, wsId);
    if (localWsList[0] === wsId) {
      // 消息盒子推送，仅推送状态，消息数量通过接口获取
      createWsConnect();
    }
  };

  const reCreatMqtt = () => {
    if (!mqtt.isConnected()) {
      const localWsList = JSON.parse(localStorage.getItem('wsList') || '[]');
      const index = localWsList.indexOf(wsId);
      if (index >= 0) {
        localWsList.splice(index, 1);
        localWsList.unshift(wsId);
      } else {
        localWsList.unshift(wsId);
      }
      // 由于storage事件只会在同一浏览器中不同标签页间触发 当前标签页需手动创建连接
      createWsConnect();
      
      localStorage.setItem('wsList', JSON.stringify(localWsList));
    }
  };

  return {
    setWsResCb,
    wsRes,
    wsSendTime,
    wsId,

    msgCb,
    removeWsId,
    initMqtt,
    undloadMqttHandler,
    createWsConnect,
    reCreatMqtt,
  };
}
